module.exports = __webpack_public_path__ + "img/miller-high-logo-phrase.a5c2601a.png";